import type {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  QueryReturnValue,
} from '@reduxjs/toolkit/query';

export function defaultHeaders(headers: Headers, token?: string) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set('Authorization', `Bearer ${token}`);
  }

  defaultHeader.set('ngrok-skip-browser-warning', 'true');

  return defaultHeader;
}

export async function defaultErrorMsg(
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>,
) {
  if (result.error) {
    console.log('Unauthorized Log', result);
  }
  if (
    result.error &&
    result.error?.status === 401
    // (result?.error?.data as any)?.message === "Unauthorized"
  ) {
    try {
      localStorage.clear();
    } catch (err) {
      console.error('Logout failed:', err);
    }
  }
}
